export default __webpack_public_path__ + "static/media/VO_PH.a354617d.gif";